"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarMining = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var LunarMining = (function (_super) {
    __extends(LunarMining, _super);
    function LunarMining() {
        return _super.call(this, {
            cost: 11,
            tags: [Tags_1.Tags.EARTH],
            name: CardName_1.CardName.LUNAR_MINING,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C22',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.titanium(1).slash().earth(2, { played: Options_1.played });
                    });
                }),
                description: 'Increase your titanium production 1 step for every 2 Earth tags you have in play, including this.',
            },
        }) || this;
    }
    LunarMining.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, Math.floor((player.getTagCount(Tags_1.Tags.EARTH) + 1) / 2), { log: true });
        return undefined;
    };
    return LunarMining;
}(Card_1.Card));
exports.LunarMining = LunarMining;
